import React from "react";
import { AdminmenuItem } from "../helper/constant";
import { FaBell } from "react-icons/fa";
import { Link, Navigate, Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { IoMenuSharp } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import UserAvatar from "./UserAvatar";
import VersionInfo from "./VersionInfo";
import { useDispatch, useSelector } from "react-redux";
import { resetTab, setTabData } from "../redux/slices/tabSlice";


export default function AdminLayout() {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = React.useState(false);

    const route = pathname.split('/')[2]
    console.log('route :>> ', route);
    const profileData = useSelector((state) => state.profileData.profileData);
    const storedUserInfo = JSON.parse(localStorage?.getItem("zubrus_user_data"))?.data?.userInfo;
    const userData = {
        ...storedUserInfo,
        ...profileData,
        profilePictureUrl:
            profileData?.profilePictureUrl || storedUserInfo?.profilePictureUrl,
    };

    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState);
    };

    const handleClick = (e) => {
        e.stopPropagation();
        setIsOpen(false);
    };


    return (
        <main>
            <header className="h-20 sticky top-0 bg-white z-30 border border-b px-10 md:px-4 flex items-center justify-between">
                <div className="flex items-center gap-10 h-full">
                    <Link to={userData?.userRoles?.length === 1 && userData?.userRoles[0] === "zubrus_admin" ? "#" : '/classes'}>
                        <img
                            onClick={() => {
                                dispatch(setTabData("classes"));
                            }}
                            src="/assets/images/LOGO.png"
                            alt="LOGO"
                            className="flex cursor-pointer"
                        />
                    </Link>
                    <ul className="flex items-center gap-5  md:hidden text-xl h-full text-lightgray font-semibold">
                        {AdminmenuItem?.map(({ title, path }) => (
                            <Link
                                to={`/admin${path}`}
                                className={`${title === route && "border-b border-black text-black "
                                    }  h-full  flex items-center  capitalize justify-center cursor-pointer`}
                            >
                                {/* {title} */}
                                {t(`adminmenu.${title}`)}
                            </Link>
                        ))}
                    </ul>
                </div>
                <div className="flex items-center gap-5 text-lightgray h-full">
                    <div className="md:hidden">
                        <FaBell fontSize={24} />
                    </div>
                    <Link
                        to="/profile"
                        className="h-full"
                        onClick={() => dispatch(resetTab(""))}
                    >
                        <div
                            className={`${pathname.includes("profile") ||
                                pathname.includes("user-info") ||
                                pathname.includes("change-password")
                                ? "text-black border-b border-black"
                                : "text-lightgray"
                                } text-xl font-semibold flex h-full items-center gap-3`}
                        >
                            <span className="md:hidden capitalize"> {userData?.firstName} {userData?.lastName?.slice(0, 1)}. </span>
                            <UserAvatar
                                src={userData?.profilePictureUrl}
                                firstName={userData?.firstName}
                                lastName={userData?.lastName}
                                username={userData?.username}
                                email={userData?.email}
                                size="sm"
                            />
                        </div>
                    </Link>
                    <div onClick={toggleDrawer} className="hidden md:flex">
                        <IoMenuSharp fontSize={24} />
                        <Drawer
                            open={isOpen}
                            onClose={toggleDrawer}
                            direction="left"
                            className="bla bla bla"
                        >
                            <div>
                                <ul className="flex flex-col items-start p-5 gap-5 text-xl h-full text-lightgray font-semibold">
                                    {AdminmenuItem?.map(({ title, path }) => (
                                        <Link
                                            to={`/admin${path}`}
                                            className={`${title === route && "border-b border-black text-black "
                                                }  h-full  flex items-center  capitalize justify-center cursor-pointer`}
                                        >
                                            {/* {title} */}
                                            {t(`adminmenu.${title}`)}
                                        </Link>
                                    ))}
                                </ul>
                            </div>
                        </Drawer>
                    </div>
                </div>
            </header>
            <section className="min-h-screen px-10 md:px-4 pt-5 bg-secondarygray">
                <Outlet />
            </section>

            <footer className="bg-white py-5 ms-5 flex items-center justify-between">
                <span className="regular-text text-lightgray">{t("copyright")}</span>
                <VersionInfo className="mr-5 relative" showDetails={true} />
            </footer>
        </main>
    )
}
